export enum LogisticTypeEnum {
    DISTRIBUITION = 'distribuicao',
    PRIMARY = 'primaria',
    AGRONOMY = 'agro',
    COMMODITIES = 'commodities'
}
